import React from 'react';
import { StatCard } from '../dashboard/StatCard';
import { cn } from '../../lib/utils';

export function IntegrationsSummary({ items = [], className }) {
  const connected = items.filter((item) => item.status === 'connected').length;
  const attention = items.filter((item) => item.status === 'error').length;
  const ready = items.filter(
    (item) => item.available !== false && item.status === 'disconnected'
  ).length;

  return (
    <div className={cn('grid min-w-0 gap-4 sm:grid-cols-3', className)}>
      <StatCard
        title="Connected"
        value={connected}
        change="—"
        trend="neutral"
        context={connected ? 'Live tenant links' : 'None linked yet'}
        featured
      />
      <StatCard
        title="Ready to connect"
        value={ready}
        change="—"
        trend="neutral"
        context={ready ? 'Available providers' : 'All set or pending'}
      />
      <StatCard
        title="Needs attention"
        value={attention}
        change={attention ? 'Action' : '—'}
        trend={attention ? 'down' : 'neutral'}
        context={attention ? 'Reconnect or re-authorize' : 'All clear'}
      />
    </div>
  );
}
